<script setup lang="ts">
import { ChevronRightIcon, ClipboardListIcon } from "lucide-vue-next";
import type { PurchaseListResponse } from "../../../responses/PurchaseListResponse";
import { label } from "../../mixins/translations";
import Modal from "../Modal.vue";

interface Props {
    open: boolean;
    lists: PurchaseListResponse[];
}

defineProps<Props>();

const emit = defineEmits<{
    (e: "update:open", value: boolean): void;
    (e: "select", list: PurchaseListResponse): void;
}>();

const select = (list: PurchaseListResponse) => {
    emit("select", list);
    emit("update:open", false);
};
</script>

<template>
    <Modal :open="open" @updateOpen="(value) => emit('update:open', value)">
        <template #trigger-wrapper>&nbsp;</template>
        <template #title>
            {{ label('site.purchase-lists.select.title') }}
        </template>

        <div class="-mx-1 max-h-80 overflow-y-auto px-1 py-1">
            <ul class="flex flex-col gap-2">
                <li v-for="list in lists" :key="list.id">
                    <button
                        type="button"
                        @click="select(list)"
                        class="group flex w-full items-center gap-3 rounded-xl border border-secondary-200 bg-white p-3 text-left transition-colors duration-200 hover:border-primary-300 hover:bg-primary-100 focus-visible:outline-hidden focus-visible:ring-3 focus-visible:ring-primary-100"
                    >
                        <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-secondary-500 transition-colors duration-200 group-hover:bg-white group-hover:text-primary-500">
                            <ClipboardListIcon class="h-4 w-4"/>
                        </span>

                        <span class="min-w-0 flex-1 truncate text-sm font-medium text-secondary-700">
                            {{ list.name }}
                        </span>

                        <ChevronRightIcon
                            aria-hidden="true"
                            class="h-4 w-4 shrink-0 text-secondary-300 transition-colors duration-200 group-hover:text-primary-500"
                        />
                    </button>
                </li>
            </ul>
        </div>
    </Modal>
</template>
